import React, { useState, useEffect } from 'react'
import AdminLayout from '../AdminLayout'
import { useTranslation } from 'react-i18next';
import { INVOICE_ORDER, GET_INVOICE_NUMBER } from '../../../data/url';
import httpClient from '../../../http/HttpRequest';
import ProductCal from '../layout/ProductCal';
import Helper from '../../../helper/Helper';
import Alert from '../../../feature/Alert';
import { useNavigate } from 'react-router-dom';
import SelectCustomer from '../layout/SelectCustomer';

export default function Invoice() {

     const [state_id, setStateId] = useState('');
     const [customerId, setCustomerId] = useState('');
     const [customer, setCustomer] = useState({});
     const [errors, setErrors] = useState({});
     const { t } = useTranslation();
     const navigate = useNavigate();  

     const [orderDetails, setOrderDetails] = useState({ prefix: '', invoice_number: '', invoice_date: Helper.getToday(), due_date: '' });

     useEffect(() => {
          getInvoiceNumber();
     }, [])

     const getInvoiceNumber = async (e) => {
          const res = await httpClient.post(GET_INVOICE_NUMBER, {});
          if (res.requestStatus === "OK") {
               const result = res.result;
               if (result.status === 1) {
                    setOrderDetails(prevOrderDetails => ({
                         ...prevOrderDetails,
                         prefix: result.prefix || '',
                         invoice_number: result.invoice_number || ''
                    }));
               }
          }
     }
     const handelSubmit = (products, commanData, totals, txnType, payment) => {
          if (validateField()) {
               if (products.length > 0) {
                    let p = orderDetails;
                    p['customer_id'] = customerId;
                    p['state'] = state_id;
                    p['products'] = products;
                    p['totals'] = totals;
                    p['commonData'] = commanData;
                    p['txnType'] = txnType;
                    p['paymentDetails'] = payment;
                    saveOrder(p);
               } else {
                    Alert.error('Products are empty');
               }

          }
     }

     const saveOrder = async (post) => {
          const res = await httpClient.post(INVOICE_ORDER, post);
          if (res.requestStatus === "OK") {
               const result = res.result;
               if (result.status === 1) {
                    Alert.success(result.message);
                    navigate('/root/invoices');
               } else {
                    Alert.failure(result.message);
               }
          }
     }

     const validateField = () => {
          let formErrors = {};
          let valid = true;
          if (customerId === '') {
               Alert.error('Select Customer');
               valid = false;
          }
          setErrors(formErrors);
          return valid;
     }

     const handleInputChange = (fieldName, event) => {
          const value = event.target.value;
          const order = { ...orderDetails };
          order[fieldName] = value;
          setOrderDetails(order);
     };

     const remitCustomer = (data) => {
          setCustomerId(data.customer_id);
          setStateId(data.state_id);
          setCustomer(data.customer);
     } 
     

     return (
          <AdminLayout>
               <div className="content-wrapper">
                    <div className='card'>
                         <div className='card-body'>
                              <div>
                                   <SelectCustomer remitCustomer={remitCustomer} />
                              </div>
                              <div className='row mt-2'>
                                   <div className='col-md-4 '>
                                        <label htmlFor='prefix'>{t('invoice_number')}</label>
                                        <div className='input-group'>
                                             <div className="input-group-prepend mr-1" style={{ width: "80px" }}>
                                                  <input id='prefix' value={orderDetails.prefix} type='text' name='prefix' className='form-control form-control-sm' onChange={(e) => handleInputChange('prefix', e)} />
                                             </div>
                                             <input id='number' value={orderDetails.invoice_number} type='text' name='invoice_number' className='form-control form-control-sm' onChange={(e) => handleInputChange('invoice_number', e)} />
                                        </div>
                                   </div>
                                   <div className='col-md-3'>
                                        <label htmlFor='invoice_date'>{t('invoice_date')}</label>
                                        <input id='invoice_date' value={orderDetails.invoice_date} type='date' name='invoice_date' className='form-control form-control-sm' onChange={(e) => handleInputChange('invoice_date', e)} />
                                   </div>
                                   <div className='col-md-3'>
                                        <label htmlFor='due_date'>{t('due_date')}</label>
                                        <input id='due_date' value={orderDetails.due_date} type='date' name='due_date' className='form-control form-control-sm' onChange={(e) => handleInputChange('due_date', e)} />
                                   </div>
                              </div>
                              <ProductCal title="invoice_details" onSubmit={handelSubmit} customer={customer} payment={true} />
                         </div>
                    </div>
               </div>
          </AdminLayout>
     )
}
